<div class="global_experience_status"
     [ngClass]="statusClassTab[status].class">
  <span class="bd-list-custom-status">{{statusClassTab[status].label | translate}} </span>
</div>
